var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('html',[_c('body',[_c('main'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h4',[_vm._v("FAFA Site Statuses "),_c('div',{staticClass:"row"})]),_c('div',{attrs:{"id":"table-container"}})])])])])])
}]

export { render, staticRenderFns }